<template>
    <div>
        <CopyToClipboard :site="`signature-${site}`" />
        <div class="signature" :id="`signature-${site}`">
            <table style="border-collapse: collapse; border: 0px solid #FFFFFF;">
                <tbody>
                    <tr>
                        <td>
                            <a v-if="siteData.url" style="text-decoration: none;" :href="siteData.url">
                                <span class="heading" v-html="siteData.heading"></span>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table v-if="!formFields.macClient" style="border-collapse: collapse; border: 0px solid #FFFFFF;">
                <tbody>
                    <tr>
                        <td v-if="siteData.facebook" width="20px">
                            <a
                            style="text-decoration: none;"
                            :href="siteData.facebook"
                            >
                            <img
                                alt="Facebook"
                                :src="socialIcons.facebook_continued"
                                style="border: 0px solid #FFFFFF"
                            >
                            </a>
                        </td>
                        <td v-if="siteData.twitter" width="20px">
                            <a style="text-decoration: none;" :href="siteData.twitter">
                            <img
                                alt="Twitter"
                                :src="socialIcons.twitter_continued"
                                style="border: 0px solid #FFFFFF"
                            >
                            </a>
                        </td>
                        <td v-if="siteData.linkedin" width="20px">
                            <a style="text-decoration: none;" :href="siteData.linkedin">
                                <img 
                                    alt="LinkedIn" :src="socialIcons.linkedin_continued"
                                    style="border: 0px solid #FFFFFF"
                                >
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div style="height: 1px; background: #FFFFFF; width: 600px; padding: 0px; margin: 0px">
            <hr>
            </div>
            <table style="border-collapse: collapse; border: 0px solid #FFFFFF; margin-top: 5px;">
                <tbody>
                    <tr>
                        <td colspan="2">
                            <div style="font-family: helvetica, arial, sans-serif; font-weight: 200; font-size: 18px; line-height: 1.0; color: #6b6b6b; text-transform: uppercase; padding-top: 13px;">
                                {{formFields.firstName}} {{formFields.lastName}}
                            </div>
                            <div style="font-family: Garamond, Georgia , serif; font-size: 17px; line-height: 1.0; color: #6b6b6b;"
                                 v-bind:style="formFields.pronouns ? 'padding: 4px 0px 0px 0px;' : 'padding: 4px 0px 8px 0px;'">
                                {{formFields.title}}
                            </div>
                            <div v-if="formFields.pronouns" style="font-family: Garamond, Georgia , serif; font-size: 17px; line-height: 1.0; color: #6b6b6b; padding: 2px 0px 8px 0px;">
                                ({{formFields.pronouns}})
                            </div>
                            <div v-if="formFields.emailUser.trim().length" style="font-family: Garamond, Georgia , serif; font-size: 13px; line-height: 1.0; padding: 0px 0 4px;">
                                <a style="color: #6b6b6b; font-weight: normal;" :href="`mailto:${formFields.emailUser}${siteData.email}`">
                                    {{formFields.emailUser}}{{siteData.email}}
                                </a>
                            </div>
                            <div v-if="siteData.phone && formFields.extension.trim().length" style="font-family: Garamond, Georgia , serif; font-size: 11px; color: #63666a; line-height: .9rem;">
                                <span style="color: #63666a;">T:</span>
                                {{siteData.phone}}, ext. {{formFields.extension}}
                            </div>
                            <div v-else-if="formFields.directLine.trim().length" style="font-family: Garamond, Georgia , serif; font-size: 11px; color: #63666a; line-height: .9rem;">
                                <span style="color: #63666a;">T:</span>
                                {{formFields.directLine}}
                            </div>


                            <div  v-if="formFields.fax.trim().length" style="font-family: Garamond, Georgia , serif; font-size: 11px; color: #63666a; line-height: .9rem;">
                                <span style="color: #63666a;">F:</span>
                                {{formFields.fax}}
                            </div>
                            <div v-if="formFields.mobile.trim().length" style="font-family: sans-serif, verdana, sans-serif; font-size: 10px; line-height: 1.0; color: #63666a;">
                                <span style="color: #63666a;">M:</span>
                                {{formFields.mobile}}
                            </div>
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import SiteData from "../../SiteData.js";
import CopyToClipboard from '../CopyToClipboard';

export default {
  name: "LaCalleGroup",
  data: function() {
    return {
      siteData: '',
      socialIcons: SiteData.socialIcons
    };
  },
  components: {
      CopyToClipboard
  },
  props: {
    formFields: Object,
    site: String
  },
  created: function() {
    this.siteData = SiteData[this.$props.site];
  }
};
</script>

